import { Phone, Clock, MapPin } from "lucide-react";
import { siteConfig } from "@/lib/site-config";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5 text-secondary shrink-0" />
            <span className="hidden lg:inline">{siteConfig.address.full}</span>
            <span className="lg:hidden">
              {siteConfig.address.city}, {siteConfig.address.state}
            </span>
          </span>
          <span className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-secondary shrink-0" />
            <span>{siteConfig.hours.summary}</span>
          </span>
        </div>
        <div className="flex items-center gap-4">
          <a
            href={siteConfig.phoneHref}
            className="flex items-center gap-2 hover:text-secondary transition-colors font-semibold"
          >
            <Phone className="h-3.5 w-3.5 text-secondary shrink-0" />
            <span>{siteConfig.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
